import * as React from "react"

const SvgPause = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 19.428q-.825 0-1.412-.587A1.93 1.93 0 0 1 14 17.428v-10q0-.824.588-1.412A1.93 1.93 0 0 1 16 5.429q.824 0 1.413.587.587.588.587 1.413v10q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.587m-8 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 17.428v-10q0-.824.588-1.412A1.93 1.93 0 0 1 8 5.429q.825 0 1.412.587.588.588.588 1.413v10q0 .825-.588 1.412A1.93 1.93 0 0 1 8 19.428" />
  </svg>
)
export default SvgPause
